import { MarketingButton } from '@/components/marketing/marketing-button'
import { MARKETING_SECTION_TITLE } from '@/components/marketing/marketing-typography'
import { cn } from '@/lib/utils'

type MarketingSplitNarrativeProps = {
  title: string
  lead?: string
  cta?: { label: string; to: string }
  className?: string
}

export function MarketingSplitNarrative({ title, lead, cta, className }: MarketingSplitNarrativeProps) {
  return (
    <div className={cn('grid items-center gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-[60px]', className)}>
      <h2 className={cn('m-0 max-w-[800px]', MARKETING_SECTION_TITLE)}>
        {title}
      </h2>
      <div>
        {lead ? (
          <p className="mb-0 max-w-[760px] text-lg leading-relaxed text-[var(--marketing-muted,#667078)]">{lead}</p>
        ) : null}
        {cta ? (
          <div className="mt-10">
            <MarketingButton href={cta.to}>{cta.label}</MarketingButton>
          </div>
        ) : null}
      </div>
    </div>
  )
}
